<template>

	<span class="d-inline-flex">

		<field
			label=""
			class="mr-2"
			col-class="col-md-3"
			v-model="selectedId"
			v-on:change="categorySelected"
			:params="{
				type: 'select',
				options: filteredOptions
		}">
		</field>

		<material-category-select
			v-if="selectedCategory && selectedCategory.children.length"
			:category-tree="selectedCategory.children"
			v-on:categorySelected="returnCategory">
		</material-category-select>


	</span>

</template>

<script>

import Field from "../Field";

export default {
	name: "MaterialCategorySelect",
	props: [
		"categoryTree",    // tree of categories
		"resetKey"         // update this to reset the selected category
	],
	components: {
		Field
	},

	data() {
		return {
			selectedId: null
		}
	},

	watch: {

		resetKey() {
			this.selectedId = false
		}

	},

	computed: {

		selectedCategory() {
			return (this.selectedId) ? this.categoryTree.find(cat => cat.id == this.selectedId) : null
		},

		filteredOptions() {
			return this.optionify(this.categoryTree, 'name')
		}
	},

	methods: {

		categorySelected(catId) {
			let selected = this.categoryTree.find(cat => cat.id == catId)

			// No children? Emit path
			if (selected && !selected.children.length) {
				this.returnCategory(selected)
			} else {
				this.returnCategory(null)
			}
		},

		returnCategory(category) {
			this.$emit('categorySelected', category)
		}

	}
}
</script>

<style scoped>

</style>